// src/api/role.api.js

import api from './axios';

export const getRolesApi = () => api.get('/roles');

export const updateRolePermissionsApi = (roleId, permissionIds) =>
  api.put(`/roles/${roleId}/permissions`, { permissionIds });
